import {
  VersionHistory,
  VersionHistoryViewModel,
} from 'src/app/core/models/self-assessment/version-history';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ImpactService } from './../../../core/services/impact/impact.service';
import { VersionHistoryFilter } from 'src/app/core/models/self-assessment/version-history-filter';
import { VersionHistoryFilterModel } from 'src/app/core/models/view-model/version-history-filter-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-impact-assessment-dialog',
  templateUrl: './impact-assessment-dialog.component.html',
  styleUrls: ['./impact-assessment-dialog.component.scss']
})
export class ImpactAssessmentDialogComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  impactAssessmentId: number;
  versionHistory: VersionHistory[];
  versionHistoryFilter: VersionHistoryFilter;
  takeCount = 0;
  skipCount = 0;
  isLoading = false;
  myInnerHeight: any;
  endIndex = 0;
  totalCount = 0;
  templateNo = 0;

  constructor(
    private impactService: ImpactService,
    public dialogRef: MatDialogRef<ImpactAssessmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public resultViewData: VersionHistoryFilterModel
  ) {
    this.myInnerHeight = window.innerHeight - 350;
    this.impactAssessmentId = resultViewData.id;
    this.templateNo = resultViewData.templateNo;
    this.versionHistory = [];
    this.versionHistoryFilter = new VersionHistoryFilter();
    // this.templateNo = resultViewData.
  }

  ngOnInit(): any {
    this.versionHistoryFilter.SortKey = 'Id';
    this.versionHistoryFilter.IsDesc = true;
    this.fetchVersionHistory();
  }

  fetchVersionHistory(): any {
    
    this.isLoading = true;
    this.versionHistoryFilter.id = this.impactAssessmentId;
    this.versionHistoryFilter.SkipCount = this.skipCount;
    this.versionHistoryFilter.TakeCount = this.takeCount;
    if(this.templateNo == 4){
      this.impactService.getVersionHistoryT4(this.versionHistoryFilter).subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    if(this.templateNo == 5){
      this.impactService.getVersionHistoryT5(this.versionHistoryFilter).subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    if(this.templateNo ==6){
      this.impactService.getVersionHistoryT6(this.versionHistoryFilter).subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    else{
      this.impactService.getVersionHistory(this.versionHistoryFilter).subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
  }

  handler(): any {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  sortVersionHistory(key: string): any {
    this.versionHistoryFilter.IsDesc = !this.versionHistoryFilter.IsDesc;
    this.versionHistoryFilter.SortKey = key;
    this.fetchVersionHistory();
  }
}
